import { Row, ListGroup, Tab, Tabs } from 'react-bootstrap';
import '../styles/components/info-modal-section.scss';
import AccordionCard from './AccordionCard';
import AccordionContainer from './AccordionContainer';
import FormatTable from './FormatTable';

const PaymentFileDescription = () => {
  return (
    <>
      <Row className="section">
        <h2>Overview</h2>
        <p className="text-start">
          This allows you to submit the properties you intend to pay. You may submit this file
          several times. Once you indicate you want to finalize this, the dollar amount for you to
          submit will be displayed.
        </p>
        <p className="text-start">
          The first record in the file should always be a Company Record, followed by all relevant
          Property Records.
        </p>
        <p className="fw-bold">
          ** At this time you will be locked out from any further changes. **
        </p>
        <p className="text-start">
          You may see any errors by going to the “View/Correct Payment File Errors” link
        </p>
      </Row>
      <AccordionContainer id="paymentFileAccordion">
        <AccordionCard title="Edits" parent="paymentFileAccordion">
          <ListGroup variant="flush">
            <ListGroup.Item>- Valid serial number for year processing</ListGroup.Item>
            <ListGroup.Item>- Payment that will constitute an overpayment</ListGroup.Item>
            <ListGroup.Item>- Other tax service requested information</ListGroup.Item>
            <ListGroup.Item>- Amount of payment is the amount due</ListGroup.Item>
          </ListGroup>
        </AccordionCard>
        <FormatTable title="Payment File" format="old" />
        <AccordionCard title="Payment Methods" parent="paymentFileAccordion">
          <Tabs defaultActiveKey="eft" className="mb-3">
            <Tab eventKey="eft" title="EFT">
              <h3>Electronic Funds Transfer</h3>
              <p>
                ACH Transfer WIRE Transfer Effective date or “Good Funds” must be on or before
                November 30th. For instructions on this process and institution information please
                contact <b>801-851-8258</b>.
              </p>
            </Tab>
            <Tab eventKey="check" title="Check">
              <h3>Company or Certified Check</h3>
              <p>
                If you process for multiple companies, please submit only one check that covers all
                accounts. Mailed payments must be postmarked by the United States Postal Service on
                or before November 30th. An office postage meter is NOT considered a valid Postmark
                for the November 30th deadline.
              </p>
            </Tab>
          </Tabs>
        </AccordionCard>
      </AccordionContainer>
    </>
  );
};

export default PaymentFileDescription;
